import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    errorIcon: {
        color: theme.palette.error.main
    },
    successIcon: {
        color: theme.palette.success.main
    },
    logo: {
        margin: theme.spacing(1),
        width: "100%",
        height: "auto"
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    passwordInitSection: {
        backgroundColor: theme.palette.background.paper,
        border: '1px solid lightgrey',
        borderRadius: '5px',
        padding: 15
    }
}));

export {useStyles};